import api from './api';
import {mapProjectDto} from "../dto/ProjectDTO";
import {mapUserProjectStats} from "../dto/UserProjectStats";


export const getProjectEntries = async (includeArchived = false) => {
    try {
        const res = await api.get(`/Project`, { params: { include_archived: includeArchived } });
        return res.data.map(mapProjectDto);
    } catch (err) {
        console.error("Error getting project entries:", err);
        throw err;
    }
};

export const getRecentProjects = async () => {
    const res = await api.get('/Project/recent');
    return res.data;
};

export const archiveProject = async (projectId) => {
    const res = await api.post(`/Project/${projectId}/archive`);
    return res.data;
};

export const unarchiveProject = async (projectId) => {
    const res = await api.post(`/Project/${projectId}/unarchive`);
    return res.data;
};

export const getProjectStats = async ({userId, startDate, endDate}) => {
    try {
        const url = `/Project/Stats/${userId}`;
        const body = {
            start_date: startDate,
            end_date: endDate
        };
        const res = await api.post(url, body);
        return res.data.map(mapUserProjectStats);
    } catch (err) {
        console.error("Error getting project stats entries:", err);
        throw err;
    }
};